import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserSession } from "../utils/userSession";

export default function ScheduleForm() {
    const savedSession = getUserSession();

    const [formData, setFormData] = useState({
        name: savedSession?.name || "",
        email: savedSession?.email || "",
        mobile: savedSession?.mobile || "",
        date: "",
        time: "",
        message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (
  !formData.name ||
  !formData.mobile ||
  !formData.email ||
  !formData.date ||
  !formData.time
) {
    toast.error("Please fill all fields ❌");
    return;
  }

  try {
    const response = await fetch("https://biomefarms.com/apiMail/schedule.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.status === "success") {
      toast.success("Form submitted successfully ✅");

      setFormData({
        name: "",
        email: "",
        mobile: "",
        date: "",
        time: "",
        message: ""
      });
    } else {
      toast.error("Something went wrong ❌");
    }

  } catch (error) {
    toast.error("Server error ❌");
  }
};
    return (
         <section className="biome biome-24 biome-schedule-form">
                    <ToastContainer />
                  
                    <div className="biome-element biome-element-2e6e941 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-contact ">
        
                        <div className="e-con-inner section-scroll-animation">
        
        
                            <div className="biome-element biome-element-5620815 e-con-full e-flex e-con e-child animated">
                                <div className="biome-element biome-element-1129d43 biome-widget biome-widget-metform ">

                                     <div
                                    className="biome-element biome-element-9b428e8 biome-widget biome-widget-heading animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 className="biome-heading-title biome-size-default animation__char_come">Schedule Your Visit
                                        </h2>
                                    </div>
                                </div>
        
                                <div
                                    className="biome-element biome-element-0f0b65d biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p className='title-anim'>
                                            Choose your preferred date and time, and we'll get in touch to confirm your appointment.
                                        </p>
                                    </div>
                                </div>
        

                                    <div className="biome-widget-container">
        
                                        <div id="mf-response-props-id-199" className="mf-scroll-top-no">
                                            <div className="formpicker_warper formpicker_warper_editable">
        
                                                <div className="mf-widget-container">
        
                                                    <div id="metform-wrap-1129d43-199" className="mf-form-wrapper">
                                                        <form className="metform-form-content" onSubmit={handleSubmit}>
        
                                                            <div className="metform-form-main-wrapper">
                                                                <div className="biome biome-199">
                                                                    <div
                                                                        className="biome-element biome-element-241aff9 e-flex e-con-boxed e-con e-parent">
                                                                        <div className="e-con-inner">
        
                                                                            <div className="biome-element biome-element-d1da4a8 biome-widget biome-widget-mf-listing-fname">
                                                                                <div className="biome-widget-container">
                                                                                    <div className="mf-input-wrapper">
                                                                                        <label className="mf-input-label" htmlFor="mf-input-text-d1da4a8">Your Name <span
                                                                                                className="mf-input-required-indicator"></span></label>
                                                                                        <input type="text"  className="mf-input " name="name" value={formData.name} onChange={handleChange} required aria-invalid="false" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
        
                                                                            <div className="biome-group-input">
                                                                                <div className="biome-element biome-element-3f98bf9 biome-widget biome-widget-mf-email">
                                                                                    <div className="biome-widget-container">
                                                                                        <div className="mf-input-wrapper">
                                                                                            <label className="mf-input-label" htmlFor="mf-input-email-3f98bf9">Email <span className="mf-input-required-indicator"></span></label>
                                                                                            <input type="email"  className="mf-input " name="email" value={formData.email} onChange={handleChange} required aria-invalid="false" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
            
                                                                                <div className="biome-element biome-element-a4235a9 biome-widget biome-widget-mf-telephone">
                                                                                    <div className="biome-widget-container">
                                                                                        <div className="mf-input-wrapper">
                                                                                            <label className="mf-input-label" htmlFor="mf-input-telephone-a4235a9">Phone <span className="mf-input-required-indicator"></span></label>
                                                                                            <input type="tel" className="mf-input " name="mobile" value={formData.mobile} onChange={handleChange} required aria-invalid="false" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                             <div className="biome-group-input">
                                                                                <div className="biome-element biome-element-3f98bf9 biome-widget biome-widget-mf-email">
                                                                                    <div className="biome-widget-container">
                                                                                        <div className="mf-input-wrapper">
                                                                                            <label className="mf-input-label" htmlFor="mf-input-email-3f98bf9">Preferred Date <span className="mf-input-required-indicator"></span></label>
                                                                                            <input type="date" className="mf-input " name="date" value={formData.date} onChange={handleChange}  onClick={(e) => e.target.showPicker()} required aria-invalid="false" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
            
                                                                                <div className="biome-element biome-element-a4235a9 biome-widget biome-widget-mf-telephone">
                                                                                    <div className="biome-widget-container">
                                                                                        <div className="mf-input-wrapper">
                                                                                            <label className="mf-input-label" htmlFor="mf-input-telephone-a4235a9">Preferred Time <span className="mf-input-required-indicator"></span></label>
                                                                                            <input type="time" className="mf-input " name="time" value={formData.time} onChange={handleChange}  onClick={(e) => e.target.showPicker()} required aria-invalid="false" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
        
                                                                            <div className="biome-element biome-element-a429567 biome-widget biome-widget-mf-textarea">
                                                                                <div className="biome-widget-container">
                                                                                    <div className="mf-input-wrapper">
                                                                                        <label className="mf-input-label" htmlFor="mf-input-text-area-a429567">Your Message <span className="mf-input-required-indicator"></span></label>
                                                                                        <textarea className="mf-input mf-textarea " id="mf-input-text-area-a429567" name="mf-textarea" placeholder="Your message here " cols={30} rows={10} aria-invalid="false"></textarea>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
        
                                                                            <div className="biome-element biome-element-e828f1d mf-btn--justify mf-btn--tablet-justify mf-btn--mobile-justify biome-widget biome-widget-mf-button">
                                                                                <div className="biome-widget-container">
                                                                                    <div className="mf-btn-wraper">
                                                                                        <button type="submit" className="metform-btn metform-submit-btn "><span>Send Message </span></button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
        
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
        
                                                </div>
        
                                            </div>
                                        </div>                                         
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
    )}